export const CallOtp = (value) => {
  return {
    telephone: value.telephone,
  };
};
export const VerifyOtp = (value) => {
  return {
    otpCode: value.otpCode,
    otpRef: value.otpRef,
    telephone: value.telephone,
    lineUid: value.lineUid,
    lineName: value.lineName,
    isPolicyAccept: true,
  };
};
export const InsertWarranty = (value) => {
  const mobiles = Array.isArray(value.mobiles)
    ? value.mobiles.map((m) => ({
        mobileBrandId: Number(m.mobileBrandId),
        mobileModelName: String(m.mobileModelName || '').trim(),
      }))
    : [];
  return {
    invImage: value.invImage ? value.invImage.originFileObj : null,
    packageImage: value.packageImage ? value.packageImage.originFileObj : null,
    telephone: value.telephone,
    fullName: value.fullName,
    mobiles: JSON.stringify(mobiles),
    channelBuyId: value.channelBuyId,
    productId: value.productId,
  };
};
export const InsertClaim = (value) => {
  const ids = Array.isArray(value.warrantyMobileIds) ? value.warrantyMobileIds.map((n) => Number(n)) : [];
  const other = String(value.warrantyMobileOtherReason || '').trim();
  return {
    claimImage: value.claimImage ? value.claimImage.originFileObj : null,
    receiptImage: value.receiptImage ? value.receiptImage.originFileObj : null,
    warrantyId: value.warrantyId,
    customerCode: value.customerCode,
    detail1: value.detail1,
    detail2: value.detail2,
    breakdownId: value.breakdownId,
    breakdownSubId: Number(value.breakdownSubId) || 0,
    warrantyMobileIds: JSON.stringify(ids),
    ...(ids.includes(-1) ? { warrantyMobileOtherReason: other } : {}),
    addressLine1: value.addressLine1,
    addressLine2: value.addressLine2,
    subDistrictId: value.subDistrictId,
    zipCode: value.zipcode,
    other: value.other,
    isCreateNewAddress: value.isCreateNewAddress,
  };
};
